import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-57ba63b2"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Dashboard", -1))
const _hoisted_2 = { class: "stats row" }
const _hoisted_3 = { class: "charts row" }
const _hoisted_4 = { class: "charts row" }

import {reactive, onMounted} from "vue";
import UsersIcon from "@/assets/stats-users.svg";
import ProjectsIcon from "@/assets/stats-projects.svg";
import StorageIcon from "@/assets/stats-storage.svg";
import JobsIcon from "@/assets/stats-jobs.svg";
import DashboardLayout from "@/views/layouts/DashboardLayout.vue";
import StatsWidget from "../../components/Pages/Dashboard/StatsWidget.vue";
import DashboardBarChart from "../../components/Pages/Dashboard/DashboardBarChart.vue";
import { DashboardInfoData } from "@/swagger";
import { useDataStore } from "@/store/data-store";
import { Utils } from "@/classes/utils/utils";
import { SeriesData } from "echarts/types/dist/shared";


export default /*#__PURE__*/_defineComponent({
  __name: 'DashboardPage',
  setup(__props) {

const dataStore = useDataStore();

const data = reactive({
	dashboardInfo: null as DashboardInfoData,
	newUsersChartData: {},
	jobProcessingChartData: {},
	newProjectsChartData: {},
	jobsChartData: {},
	jobWaitingTime: {}
})

function createVerticalMultiBarChartData(categories: string[], values: SeriesData[]){
	for(const series of values){
		(series as any).type = "bar";
	}
	return {
		tooltip: {
			show: true,
		},
		xAxis: {
			type: "category",
			data: categories
		},
		yAxis: {
			type: "value"
		},
		series: values
	};
}

function createVerticalBarChartData(categories: string[], values: number[]){
	return {
		tooltip: {
			show: true,
		},
		xAxis: {
			type: "category",
			data: categories
		},
		yAxis: {
			type: "value"
		},
		series: [
			{
				data: values,
				type: "bar"
			}
		]
	};
}

function createHorizontalBarChartData(categories: string[], values: number[]){
	return {
		tooltip: {
			show: true,
		},
		yAxis: {
			type: "category",
			data: categories
		},
		xAxis: {
			type: "value"
		},
		series: [
			{
				data: values,
				type: "bar"
			}
		]
	};
}

function getData(){
	dataStore.getDashboardInfo().then((dashboardInfo)=>{
		data.dashboardInfo = dashboardInfo;
	});

	dataStore.getNewUsersChartData().then((chartData)=>{
		if(!chartData){
			return;
		}
		data.newUsersChartData = createVerticalBarChartData(chartData.barTitles,chartData.barValues);
	})

	dataStore.getNewProjectsChartData().then((chartData)=>{
		if(!chartData){
			return;
		}
		data.newProjectsChartData = createVerticalBarChartData(chartData.barTitles,chartData.barValues);
	});

	dataStore.getCompletedOrFailedJobsChartData().then((chartData)=>{
		if(!chartData){
			return;
		}
		data.jobsChartData = createVerticalMultiBarChartData(chartData.barTitles, chartData.barValues);
	});

	dataStore.getJobWaitingTimeChartData().then((chartData)=>{
		if(!chartData){
			return;
		}
		data.jobWaitingTime = createHorizontalBarChartData(chartData.barTitles, chartData.barValues);
	});

	dataStore.getJobProcessingChartData().then((chartData)=>{
		if(!chartData){
			return;
		}
		data.jobProcessingChartData = createHorizontalBarChartData(chartData.barTitles, chartData.barValues);
	});
}

onMounted(()=>{
	getData();
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DashboardLayout, null, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createVNode(StatsWidget, {
          class: "col mt-4",
          icon: _unref(UsersIcon),
          value: data.dashboardInfo?.totalUsers,
          description: "Total users",
          link: "/dashboard/users"
        }, null, 8, ["icon", "value"]),
        _createVNode(StatsWidget, {
          class: "col mt-4",
          icon: _unref(ProjectsIcon),
          value: data.dashboardInfo?.totalProjects,
          description: "Total projects",
          link: "/dashboard/projects"
        }, null, 8, ["icon", "value"]),
        _createVNode(StatsWidget, {
          class: "col mt-4",
          icon: _unref(StorageIcon),
          value: _unref(Utils).formatBytes(data.dashboardInfo?.usedStorage),
          description: "Used storage",
          link: "/dashboard/projects"
        }, null, 8, ["icon", "value"]),
        _createVNode(StatsWidget, {
          class: "col mt-4",
          icon: _unref(JobsIcon),
          value: data.dashboardInfo?.dailyJobs,
          description: "Daily jobs"
        }, null, 8, ["icon", "value"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(DashboardBarChart, {
          option: data.newUsersChartData,
          title: "New users",
          class: "col mt-4",
          link: "/dashboard/users?sortProperty=createdDate"
        }, null, 8, ["option"]),
        _createVNode(DashboardBarChart, {
          option: data.newProjectsChartData,
          title: "New projects",
          class: "col mt-4",
          link: "/dashboard/projects?sortProperty=createdDate"
        }, null, 8, ["option"]),
        _createVNode(DashboardBarChart, {
          option: data.jobsChartData,
          title: "Jobs",
          class: "col mt-4",
          link: "/monitor/queues/queue/data-processor "
        }, null, 8, ["option"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(DashboardBarChart, {
          option: data.jobProcessingChartData,
          title: "Job processing",
          class: "col mt-4"
        }, null, 8, ["option"]),
        _createVNode(DashboardBarChart, {
          option: data.jobWaitingTime,
          title: "Job waiting time",
          class: "col mt-4"
        }, null, 8, ["option"])
      ])
    ]),
    _: 1
  }))
}
}

})